import request from '@/router/axios';

export const planStockAmountTotal = (row={}) => {
    return request({
        url: '/api/produce/transport-plan/planStockAmountTotal',
        method: 'post',
        data: {
            businessType: 3,
            stockQuery: 0, ...row
        }
    })
}
// 发货趋势分析、月度发货规律
export const planExecuteAmountByMonth = (row = {}) => {
    return request({
        url: '/api/produce/transport-plan/planExecuteAmountByMonth',
        method: 'post',
        data: {
            businessType: 3,
             ...row
        }
    })
}
// 发货量分布
export const planExecuteAmountDistribute = (row = {}) => {
    return request({
        url: '/api/produce/transport-plan/planExecuteAmountDistribute',
        method: 'post',
        data: {
            businessType: 3,
            ...row
        }
    })
}
